import { useNode } from '@craftjs/core';
import { getEditorTextLinkDynamicValueHelperProps } from '@utils/tooltips';
import DynamicValueHelperText from '@components/Tooltips/DynamicValuesHelperText';
import { upperFirst } from 'lodash';
import {
	AutocompleteControl,
	SwitchControl,
	TextControl,
	ToggleButtonGroupControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import {
	horizontalAlignmentOptions,
	TypographyVariantsOptions,
	VariantsOptions
} from '../constants';

const EditorTextSettings = () => {
	const {
		children,
		typography,
		align,
		fullWidth,
		variant,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [
		onChildrenChange,
		onTypographyChange,
		onAlignChange,
		onFullWidthChange,
		onVariantChange
	] = useMemo(
		() =>
			['children', 'typography', 'align', 'fullWidth', 'variant'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	return (
		<div>
			<TextControl
				value={children}
				label={intl.tr('screenEditor.settings.text')}
				setValue={onChildrenChange}
				helperText={
					<DynamicValueHelperText
						{...getEditorTextLinkDynamicValueHelperProps(intl.tr)}
					/>
				}
			/>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.style')}
				setValue={onTypographyChange}
				value={typography}
				options={TypographyVariantsOptions}
				getOptionLabel={(o) => upperFirst(o as string)}
			/>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.color')}
				setValue={onVariantChange}
				value={variant}
				options={VariantsOptions}
				getOptionLabel={(o) => upperFirst(o as string)}
			/>
			<ToggleButtonGroupControl
				data-testid="horizontal-alignment"
				label={intl.tr('screenEditor.settings.alignment')}
				options={horizontalAlignmentOptions}
				value={align}
				setValue={onAlignChange}
			/>
			<SwitchControl
				value={fullWidth}
				label={intl.tr('screenEditor.settings.fullWidth')}
				setValue={onFullWidthChange}
			/>
		</div>
	);
};

export { EditorTextSettings };
